import moji from "moji";

const FULLWIDTH_SPACE = "　";

/** 氏名の前後のスペース（半角・全角）のみ削除 */
function trimClientNameEdges(value: string): string {
  return value.replace(/^[\s\u3000]+|[\s\u3000]+$/g, "");
}

/** 半角英数・半角カナを全角に変換 */
export function normalizeZenkakuChars(value: string): string {
  return moji(value).convert("HE", "ZE").convert("HK", "ZK").toString();
}

/** 名義用: スペース除去 + 全角変換 */
export function normalizeClientName(value: string): string {
  const removedSpace = value.replace(/[\s\u3000]+/g, "");
  return normalizeZenkakuChars(removedSpace);
}

/** 姓名用: 前後トリム + 全角変換 */
export function normalizePersonName(value: string): string {
  return normalizeZenkakuChars(trimClientNameEdges(value));
}

/** カナ用: スペース除去 + 全角変換 */
export function normalizeKanaName(value: string): string {
  const removedSpace = value.replace(/[\s\u3000]+/g, "");
  return normalizeZenkakuChars(removedSpace);
}

function normalizeClientNameChars(value: string): string {
  return normalizeZenkakuChars(value);
}

/** 名義文字列を姓・名に分割（全角スペース区切り） */
export function splitClientName(fullName: string): { lastName: string; firstName: string } {
  const parts = fullName.split(FULLWIDTH_SPACE);
  if (parts.length < 2) {
    return { lastName: fullName, firstName: "" };
  }
  return {
    lastName: parts[0],
    firstName: parts.slice(1).join(FULLWIDTH_SPACE),
  };
}

/** 姓・名を全角スペースで結合（backend toPersonClientName と同様） */
export function combineClientName(lastName: string, firstName: string): string {
  const combined = `${trimClientNameEdges(lastName)}${FULLWIDTH_SPACE}${trimClientNameEdges(firstName)}`;
  return normalizeClientNameChars(combined);
}

/** セイ・メイを全角スペースで結合 */
export function combineClientNameKana(lastNameKana: string, firstNameKana: string): string {
  return `${trimClientNameEdges(lastNameKana)}${FULLWIDTH_SPACE}${trimClientNameEdges(firstNameKana)}`;
}
